import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgWeb = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333zm-.667 11.954A5.326 5.326 0 0 1 2.667 8c0-.413.053-.807.14-1.193L6 10v.667C6 11.4 6.6 12 7.333 12v1.287zm4.6-1.694a1.323 1.323 0 0 0-1.266-.926H10v-2C10 8.3 9.7 8 9.333 8h-4V6.667h1.334c.366 0 .666-.3.666-.667V4.667h1.334c.733 0 1.333-.6 1.333-1.334V3.06A5.336 5.336 0 0 1 13.333 8a5.305 5.305 0 0 1-1.4 3.593z",
		fillRule: "nonzero"
	})
});
export default SvgWeb;
